import React from "react";

import type { ColumnMetaData } from "../_components/column";

export type TableColumnContextType = {
    columns: ColumnMetaData[];
    /** Leaf columns in on-screen order; body cells inherit column-level props from these by index */
    leafColumns: ColumnMetaData[];
    content: React.ReactNode;
    maxDepth: number;
    leafCount: number;
};

export const TableColumnContext = React.createContext<TableColumnContextType | null>(null);

export function useTableColumnContext(): TableColumnContextType {
    const context = React.useContext(TableColumnContext);

    if (!context) {
        throw new Error("Missing table column context. Table elements must be used within a Table.Root component.");
    }

    return context;
}
